import { render, staticRenderFns } from "./Connect.vue?vue&type=template&id=384a5f88&scoped=true"
import script from "./Connect.vue?vue&type=script&lang=js"
export * from "./Connect.vue?vue&type=script&lang=js"
import style0 from "./Connect.vue?vue&type=style&index=0&id=384a5f88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.46.0__css-load_ecc709542230bcceb67dd6366ef941ae/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384a5f88",
  null
  
)

export default component.exports